// @flow

import routes from 'app/member-home/routes';

export {
  default as MaybeCompleteGoalsAndCelebrate,
  LazyLoadMaybeCompleteGoalsAndCelebrateWithContext as MaybeCompleteGoalsAndCelebrateWithContext,
} from 'app/member-home/components/UserSkillLevels/MaybeCompleteGoalsAndCelebrate';

export default {
  routes,
};
